import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingFreeItemComponent } from './billing-free-item.component';
import { CoreModule } from 'app/core/core.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
  ],
  declarations: [BillingFreeItemComponent],
  entryComponents: [BillingFreeItemComponent]
})
export class BillingFreeItemModule { }
